import React from 'react'
import { useTranslation } from 'react-i18next'

export default function About() {
  const { t } = useTranslation();

  return (
    <>

    {/* <!-- BREADCRUMBS --> */}
    <section className="page-section breadcrumbs text-center">
        <div className="container">
            <div className="page-header">
      <h2><strong>Despre Noi</strong></h2>
            </div>
            <ul className="breadcrumb">
                <li><a href="index.html">Acasa</a></li>
                <li className="active">Despre noi</li>
            </ul>
        </div>
    </section>
    {/* <!-- /BREADCRUMBS --> */}

    {/* <!-- PAGE --> */}
    <section className="page-section color">
        <div className="container">
            <p className="text-center lead"><strong>Moto4Rent:</strong> Suntem o echipa de pasionati ai motocicletelor, cu o vechime de peste 20 ani de experienta moto: consilieri vanzari motociclete, mecanici de motociclete sau instructori moto. Suntem in masura sa oferim consiliere, raspunsuri la probleme, asistenta in alegerea motocicletei potrivite..</p>
            <hr className="page-divider"/>
            <div className="row">
                <div className="col-md-3">
                    <div className="thumbnail thumbnail-team no-border no-padding">
                        <div className="media">
                            <img src="assets/img/preview/team/team-270x270x1.jpg" alt=""/>
                        </div>
                        <div className="caption">
                            <h4 className="caption-title">Catalin Ionescu <small>Fondator Moto4Rent</small></h4>
                            <ul className="social-icons">
                                <li><a href="#" className="facebook"><i className="fa fa-facebook"></i></a></li>
                                <li><a href="#" className="twitter"><i className="fa fa-twitter"></i></a></li>
                                <li><a href="#" className="instagram"><i className="fa fa-instagram"></i></a></li>
                                <li><a href="#" className="pinterest"><i className="fa fa-pinterest"></i></a></li>
                            </ul>
                            <div className="caption-text">Am creat Moto4Rent din pasiunea mea pentru motociclete. Suntem pe piata din Romania din 2013 si in tot acest timp am avut o evolutie ascendenta. Flota de motociclete a crescut si am incercat sa venim in ajutorul fiecarui client in parte.</div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="thumbnail thumbnail-team no-border no-padding">
                        <div className="media">
                            <img src="assets/img/preview/team/team-270x270x2.jpg" alt=""/>
                        </div>
                        <div className="caption">
                            <h4 className="caption-title">Standard Name <small>Support team</small></h4>
                            <ul className="social-icons">
                                <li><a href="#" className="facebook"><i className="fa fa-facebook"></i></a></li>
                                <li><a href="#" className="twitter"><i className="fa fa-twitter"></i></a></li>
                                <li><a href="#" className="instagram"><i className="fa fa-instagram"></i></a></li>
                                <li><a href="#" className="pinterest"><i className="fa fa-pinterest"></i></a></li>
                            </ul>
                            <div className="caption-text"></div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="thumbnail thumbnail-team no-border no-padding">
                        <div className="media">
                            <img src="assets/img/preview/team/team-270x270x3.jpg" alt=""/>
                        </div>
                        <div className="caption">
                            <h4 className="caption-title">Standard Name <small>Support team</small></h4>
                            <ul className="social-icons">
                                <li><a href="#" className="facebook"><i className="fa fa-facebook"></i></a></li>
                                <li><a href="#" className="twitter"><i className="fa fa-twitter"></i></a></li>
                                <li><a href="#" className="instagram"><i className="fa fa-instagram"></i></a></li>
                                <li><a href="#" className="pinterest"><i className="fa fa-pinterest"></i></a></li>
                            </ul>
                            <div className="caption-text"></div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="thumbnail thumbnail-team no-border no-padding">
                        <div className="media">
                            <img src="assets/img/preview/team/team-270x270x4.jpg" alt=""/>
                        </div>
                        <div className="caption">
                            <h4 className="caption-title">Standard Name <small>Support team</small></h4>
                            <ul className="social-icons">
                                <li><a href="#" className="facebook"><i className="fa fa-facebook"></i></a></li>
                                <li><a href="#" className="twitter"><i className="fa fa-twitter"></i></a></li>
                                <li><a href="#" className="instagram"><i className="fa fa-instagram"></i></a></li>
                                <li><a href="#" className="pinterest"><i className="fa fa-pinterest"></i></a></li>
                            </ul>
                            <div className="caption-text"></div>
                        </div>
                    </div>
                </div>
            </div>
    
            <hr className="page-divider"/>				
    <div className="row">
               <ul className="list-icons">
                        <li><i className="fa fa-check-circle"></i>La fel ca pe motocicleta personala, dar cu mai putine griji.</li>
                        <li><i className="fa fa-check-circle"></i>Calatorie placuta si conduceti responsabil. Asfalt uscat!</li>
                    </ul>
            </div>
              <hr className="page-divider"/>
        </div>
    </section>
    {/* <!-- /PAGE --> */}

</>
  )
}
